import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { notificationSettings } from "../../constants/actionTypes";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import {
  errorNotificationSettings,
  errorNotificationTypes,
  errorNotificationTypesList,
  errorPhoneNumber,
  successNotificationSettings,
  successNotificationTypes,
  successNotificationTypesList,
  successPhoneNumber,
  successReportNotificationTypeList,
  errorReportNotificationTypeList,
  successUpdateReportNotification,
} from "../actions/notificationSettings";
import {
  getNotificationTypes,
  getNotificationTypesList,
  updateNotificationSettingsApi,
  updateProfileApi,
  getReportNotificationTypeList,
  setReportNotificationSettings,
} from "../api/notificationSettings";

export function* fetchNotificationTypes() {
  try {
    const data = yield call(getNotificationTypes);
    if (data?.status === statusCode.Ok200) {
      yield put(successNotificationTypes(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.Error);
      yield put(errorNotificationTypes(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.Error);
    yield put(errorNotificationTypes(err));
  }
}

export function* fetchNotificationTypesList({ payload }) {
  try {
    const data = yield call(getNotificationTypesList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successNotificationTypesList(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.Error);
      yield put(errorNotificationTypesList(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.Error);
    yield put(errorNotificationTypesList(err));
  }
}

export function* updateNotificationSettingsFunction({ payload }) {
  try {
    const data = yield call(updateNotificationSettingsApi, payload);
    if (data?.status === statusCode.Created201) {
      yield put(successNotificationSettings(data));
      toastNotification(toasterFlags.SUCCESS, "Notifications Settings Updated Successfully");
    } else {
      yield put(errorNotificationSettings(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.message);
    yield put(errorNotificationSettings(err));
  }
}

export function* updateProfileFunction({ payload }) {
  try {
    const data = yield call(updateProfileApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successPhoneNumber(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
    } else {
      yield put(errorPhoneNumber(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.message);
    yield put(errorPhoneNumber(err));
  }
}

export function* fetchReportNotificationTypeList() {
  try {
    const data = yield call(getReportNotificationTypeList);
    console.log(data);
    if (data?.status === statusCode.Ok200) {
      yield put(successReportNotificationTypeList(data?.data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.Error);
      yield put(errorReportNotificationTypeList(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.Error);
    yield put(errorReportNotificationTypeList(err));
  }
}

export function* updateReportNotificationSettings({ payload }) {
  try {
    const data = yield call(setReportNotificationSettings, payload);
    console.log(data);
    if (data?.status === statusCode.Created201) {
      yield put(successUpdateReportNotification(data?.data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
    } else {
      yield put(errorReportNotificationTypeList(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.message);
    yield put(errorReportNotificationTypeList(err));
  }
}

export function* notificationSettingsRootSaga() {
  yield takeLatest(notificationSettings.REQUEST_NOTIFICATION_TYPES, fetchNotificationTypes);
  yield takeLatest(notificationSettings.FETCH_NOTIFICATION_TYPES_LIST, fetchNotificationTypesList);
  yield takeLatest(notificationSettings.FETCH_REPORT_NOTIFICATION_TYPE_LIST, fetchReportNotificationTypeList);
  yield takeLatest(notificationSettings.UPDATE_REPORT_NOTIFICATION_SETTINGS, updateReportNotificationSettings);
  yield takeLatest(notificationSettings.UPDATE_NOTIFICATION_SETTINGS, updateNotificationSettingsFunction);
  yield takeLatest(notificationSettings.REQUEST_PHONE_NUMBER, updateProfileFunction);
}

export default function* rootSaga() {
  yield all([fork(notificationSettingsRootSaga)]);
}
